import { I18n } from 'react-redux-i18n';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { courseReport } from 'service/api';
import { showModal } from './modal';
var moment = require('moment');

// Constants - action names
export const SEARCH_APPLICANTS = 'pv-kultu/lessonsReport/SEARCH_APPLICANTS';
export const SEARCH_APPLICANTS_SUCCESS = 'pv-kultu/lessonsReport/SEARCH_APPLICANTS_SUCCESS';
export const SEARCH_APPLICANTS_FAILED = 'pv-kultu/lessonsReport/SEARCH_APPLICANTS_FAILED';

export const UPDATE_SEARCH_TERMS = 'pv-kultu/lessonsReport/UPDATE_SEARCH_TERMS';
export const RESET_APPLICANTS = 'pv-kultu/lessonsReport/RESET_APPLICANTS';

// Helpers
//--

// Initial state
const initialState = {
  applicants: undefined,
  loading: {
    applicants: false,
    courseLessons: false,
    saving: false
  },
  error: undefined,
  success: false,
  searchTerms: {
    lessonType: 'THEORY',
    examClass: '',
    courseNumber: '',
    courseYear: moment().format("YYYY"),
    courseUnit: '',
    applicantStatus: '',
  },
  searchTermsChanged:false,
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SEARCH_APPLICANTS:
      return Object.assign({}, state, {
        loading: { applicants: true },
        error: undefined,    
      });
    case SEARCH_APPLICANTS_SUCCESS:
      return Object.assign({}, state, {
        loading: {applicants: false},
        applicants: action.applicants,
      });
    case SEARCH_APPLICANTS_FAILED:
      return Object.assign({}, state, {
        loading: {applicants: false},
        error: action.error
      });
    case UPDATE_SEARCH_TERMS:
      return Object.assign({}, state,{ searchTerms: Object.assign({}, state.searchTerms, action.terms, {searchTermsChanged: true})});
    case RESET_APPLICANTS:
      return Object.assign({}, state, {
        loading: {applicants: false},
        applicants: [],
        error: undefined,
      });
    default:
      return state;
  }
}

// Actions
export function searchApplicantsAction(payload) {
  return {type: SEARCH_APPLICANTS, payload};
}

export function searchApplicantsSuccess(data) {
  return {type: SEARCH_APPLICANTS_SUCCESS, applicants: data};
}

export function searchApplicantsFailed(error) {
  return {type: SEARCH_APPLICANTS_FAILED, error};
}

export function updateSearchTermsAction(terms) {
  return {type: UPDATE_SEARCH_TERMS, terms}
}

export function resetApplicantsAction() {
  return {type: RESET_APPLICANTS}
}

// Sagas
export function* handleSearchApplicantLessonsSaga(action) {
  try {
    const payload = action.payload;

    const activeOnly = payload.applicantStatus === 'INCLUDE_ACTIVE';

    let data = yield call(courseReport, Object.assign({}, payload, { activeOnly }),
      {contentType: 'application/json'});

    yield put(searchApplicantsSuccess(data.applicantLessonRowList));
    if (!data || data.length <= 0) {
      const modalProps = {
        messageType: 'ERROR',
        message: I18n.t('message.no_applicants_found')
      };
      yield put(showModal('MESSAGE', modalProps));
    }
  } catch (error) {
    yield put(searchApplicantsFailed(error));
    if (error.message === 'Unauthorized') {
      yield put(showModal('LOGIN'));
    }
  }
}

function* watchSearch() {
  yield takeEvery(SEARCH_APPLICANTS, handleSearchApplicantLessonsSaga);
}

export function* lessonsReportSagas() {
  yield all([
    watchSearch(),
  ]);
}


// WEBPACK FOOTER //
// ./src/ducks/lessonsReport.js